import moment from 'moment';

export const dateTransform = date => moment(date).toISOString(true);

export const transformAppointmentToFullCalendarEvent = appointment => {
  const dateTransform = date => moment(date).toISOString(true);
  return {
    id: appointment.id,
    title: appointment.patientName,
    start: dateTransform(appointment.startTime),
    end: dateTransform(appointment.endTime),
    providerId: appointment.providerId,
    providerFullTitle: appointment.providerFullTitle,
    tenancyLocation: appointment.tenancyLocation,
    tenancyId: appointment.tenancyId,
    patientId: appointment.patientId,
    patientName: appointment.patientName,
    patientEmail: appointment.patientEmail,
    patientDOB: appointment.patientDOB,
    patientTebraId: appointment.patientTebraId,
    patientPhone: appointment.patientPhone,
    appointment: true,
    backgroundColor: appointment.tenancyColor,
    className: ['appointment'],
    resourceId: appointment.providerId,
  };
};

export const transformAvailabilityToFullCalendarEvent = ({
  start,
  end,
  providerId,
  tenancyId,
  tenancyColor,
  scheduleId
}) => {
  return {
    title: '',
    start: dateTransform(start),
    end: dateTransform(end),
    className: ['availability'],
    availability: true,
    tenancyId,
    providerId,
    borderColor: tenancyColor,
    resourceId: providerId,
    scheduleId: scheduleId
  };
};

export const transformToServerEvent = ({
  start,
  end,
  providerId,
  tenancyId,
  scheduleId,
  telemedicineId
}) => {
  return {
    start,
    end,
    providerId,
    tenancyId,
    scheduleId,
    telemedicineId
  };
};
